import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=58f1a770&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"
import style0 from "./Pause.vue?vue&type=style&index=0&id=58f1a770&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1a770",
  null
  
)

export default component.exports